var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKids(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.71974 5.96872C5.71974 5.66477 5.47233 5.41736 5.16879 5.41736C4.86444 5.41736 4.61743 5.66477 4.61743 5.96872C4.61743 6.27185 4.86403 6.52008 5.16879 6.52008C5.47233 6.52008 5.71974 6.27185 5.71974 5.96872Z",
    fill: "#787878"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26628 6.51926C8.57057 6.51926 8.81724 6.27259 8.81724 5.96831C8.81724 5.66403 8.57057 5.41736 8.26628 5.41736C7.962 5.41736 7.71533 5.66403 7.71533 5.96831C7.71533 6.27259 7.962 6.51926 8.26628 6.51926Z",
    fill: "#787878"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71516 8.18435C7.3677 8.18435 7.91128 7.72966 8.08415 7.1488H5.34741C5.51905 7.72966 6.06385 8.18435 6.71516 8.18435Z",
    fill: "#787878"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9996 1.03509C11.6318 -0.437525 10.251 0.896229 9.7074 1.55737C8.84923 0.892133 7.77395 0.495611 6.60773 0.495611C5.38048 0.495611 4.254 0.933915 3.37658 1.66265C2.90468 1.05639 1.44394 -0.52068 0 1.03509C0 1.03509 0.478857 2.71498 2.58517 2.48559C1.92976 3.33967 1.54021 4.40634 1.54021 5.56396C1.54021 8.35763 3.81365 10.6307 6.60773 10.6307C9.40182 10.6307 11.6748 8.35763 11.6748 5.56396C11.6748 4.41495 11.2906 3.35401 10.6442 2.50321C12.556 2.59209 12.9996 1.03509 12.9996 1.03509ZM6.60773 9.39563C4.49486 9.39563 2.77565 7.67642 2.77565 5.56396C2.77565 5.28377 2.80596 5.01096 2.86331 4.74797H5.31126L5.30142 3.71653L6.35581 4.74797H10.3538C10.4107 5.01137 10.4415 5.28418 10.4415 5.56396C10.4402 7.67642 8.72101 9.39563 6.60773 9.39563Z",
    fill: "#787878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKids);
export default __webpack_public_path__ + "static/media/Kids.754fecda2748a718b11d288dc279f4bb.svg";
export { ForwardRef as ReactComponent };